module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-wrapper"
  }, [_c('div', {
    staticClass: "detail-article"
  }, [_c('div', {
    staticClass: "detail-head"
  }, [_c('div', {
    staticClass: "user-avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.topic.author.avatar_url,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("\n                \t\t" + _vm._s(_vm.topic.author.loginname)), _c('span', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.topic.tab))])]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("\n                \t\t" + _vm._s(_vm._f("formatDate")(_vm.topic.create_at)) + "•"), _c('span', [_vm._v(_vm._s(_vm.topic.visit_count) + "次浏览")])])]), _vm._v(" "), (_vm.topic.is_collect === false) ? _c('a', {
    staticClass: "btn-keep",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.keepTopic(_vm.topic.id)
      }
    }
  }, [_vm._v("收藏")]) : _c('a', {
    staticClass: "btn-keep on",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.cancelTopic(_vm.topic.id)
      }
    }
  }, [_vm._v("取消收藏")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.topic.title))]), _vm._v(" "), _c('div', {
    staticClass: "detail-content",
    domProps: {
      "innerHTML": _vm._s(_vm.topic.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-comment"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("评论")]), _vm._v(" "), _vm._l((_vm.topic.replies), function(item, index) {
    return _c('div', {
      staticClass: "comment-wrapper"
    }, [_c('div', {
      staticClass: "comment-avatar"
    }, [_c('img', {
      attrs: {
        "src": item.author.avatar_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "comment-info"
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.author.loginname))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.create_at)))]), _vm._v(" "), _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn-good",
      class: {
        'on': item.is_uped
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.goodFor(item.id, index)
        }
      }
    }, [(item.ups.length > 0) ? _c('em', [_vm._v(_vm._s(item.ups.length))]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "new-comment"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userReply),
      expression: "userReply"
    }],
    staticClass: "cont",
    attrs: {
      "name": "",
      "id": "",
      "placeholder": "请输入您的评论"
    },
    domProps: {
      "value": (_vm.userReply)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userReply = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "value": "评论"
    },
    on: {
      "click": function($event) {
        _vm.postReply(_vm.topic.id)
      }
    }
  })]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading-wrapper"
  }, [_c('loading')], 1) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "showModal": _vm.showModal
    },
    on: {
      "close": _vm.closeMoal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47c2ddcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/detail.vue
// module id = 47
// module chunks = 0